import { useContext } from 'react';
import { motion } from 'framer-motion';
import { uiContext } from '@/providers/UIContextProvider';
import { Navigation } from './Navigation';

export const Header = () => {
  const { headerVisible } = useContext(uiContext);
  return (
    <motion.div
      className="absolute left-0 top-0 z-50 w-full"
      initial={{ y: -200 }}
      animate={{ y: headerVisible ? 0 : -200 }}
      transition={{ duration: 0.3, easings: 'easeInOut' }}
    >
      <header className="flex min-h-12 w-full bg-primary">
        <img
          className="flex h-14 w-32 shrink-0 object-contain px-2"
          src="content/images/logo.png"
          alt="logo"
        />

        <Navigation />
      </header>
    </motion.div>
  );
};
